/**
 * Jay@airwhizz.com
 * Description :
 *
 * @input :
 * @output :
 *
 *
 */
import React from 'react';
import { Button, Card, Col, Form, Icon, Input, Result, Row, Select, Spin } from 'antd';
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";
import MasterModal from "../../components/MasterModal";
import SubList from "../../components/SubList";
import DocumentList from "../../components/DocumentList";

class StepCreate extends React.Component {
    state = {
        finalPayload: null,
        selectedType: null,
        attributeFormItems: null,
        autoName: '',
        documentData: []
    };

    componentDidMount() {
        const { match, fetch } = this.props;
        if (match.params && match.params.id) {
            fetch(match.params.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.data && JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data)) {
            const type = nextProps.data.type;
            this.props.fetchSpareType(type._id);
        }
        if (nextProps && nextProps.sparePartTypeData && JSON.stringify(this.props.sparePartTypeData) !== JSON.stringify(nextProps.sparePartTypeData)) {
            this.setState({
                selectedType: nextProps.sparePartTypeData,
            });
        }
    }

    onSubmitMainInfo = (e) => {
        e.preventDefault();
        // const selectedType = this.state.selectedType;
        // selectedType.attributes && selectedType.attributes.map((att) => {
        //   this.props.form.validateFields([`${att._id}_name`, `${att._id}_code`], {force: true});
        // });
        this.props.form.validateFields((err, values) => {
            if (err) {
                return console.log(err);
            }

            const { documentData } = this.state;
            const data = Object.assign({}, values);

            if (documentData.length === 0) {
                data.documents = this.props && this.props.data && this.props.data.documents;
            } else {
                data.documents = documentData;
            }
            // this.props.form.validateFields([`${att._id}_name`, `${att._id}_code`], { force: true });
            // console.log(values);
            // console.log(data);
            this.props.generateSpareName(data);
            // this.setState({mainFormInfo: values});
        });
    };

    finalSubmit = () => {
        const { match } = this.props;
        if (match.params && match.params.id) {
            this.props.onSubmit(match.params.id);
        } else {
            this.props.onSubmit();
        }
    };

    cancelSubmit = () => {
        this.setState({
            finalPayload: null,
            autoName: ''
        });
        this.props.clearName();
    };

    handleTypeSelect = (types, getFieldDecorator, typeId) => {
        const selectedType = types.filter(tp => tp._id === typeId);
        this.setState({
            selectedType: selectedType[0],
        });
    };

    handleSelectAttributeName = (index, attId, value) => {
        const { setFieldsValue } = this.props.form;
        const selectedType = this.state.selectedType;
        const selectedAttribute = (selectedType.attributes || []).filter(att => att._id === attId);
        if (selectedAttribute && selectedAttribute.length) {
            const content = selectedAttribute[0].content;
            if (content && content.length) {
                const con = content.filter(c => c.name === value);
                const obj = {};
                obj[`${attId}_code`] = con && con.length && con[0].code;
                setFieldsValue({ [`${attId}_code`]: con && con.length && con[0].code });
            }
        }
    };

    getDocumentData = (data) => {
        this.setState({ documentData: data });
    };

    render() {
        const style = {
            marginTop: '10px',
            border: '1px dashed #000',
            padding: '30px',
            borderRadius: '9px',
        };
        const { getFieldDecorator, setFieldsValue } = this.props.form;
        const { data, loading, filters, title, resource, form, subMaster, superMaster, sparePartData, subDocumentFilters } = this.props;
        const selectedType = this.state.selectedType;
        // console.log(filters)
        let typeData = [];
        if (filters['type']) {
            typeData = filters['type']['data']['data'] || [];
        }
        return (
            <div>
                <Spin spinning={loading}>
                    <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}
                        style={{ paddingLeft: '1%', paddingRight: '1%' }}>
                        {data && data.name && (<h3>Name : {data.name}</h3>)}
                        {this.props.autoSpareName ?
                            <Result
                                title={`SparePart name will be : ${this.props.autoSpareName}`}
                                icon={<Icon type="tool" theme="twoTone" />}
                                extra={
                                    <div>
                                        <Button type="primary" key="save" onClick={this.finalSubmit}>
                                            Save
                                        </Button>
                                        <Button type="primary" key="cancel" onClick={this.cancelSubmit}>
                                            Cancel
                                        </Button>
                                    </div>
                                }
                            /> :
                            <Form onSubmit={this.onSubmitMainInfo} layout={'horizontal'}>
                                {Object.keys(filters).map((item) => {
                                    if (item === 'givenName' || item === 'code' || item === 'internalCode' || item === 'unitOfMeasurement' || item === 'subAssembly' || item === 'isActive') {
                                        return getFormFieldByType(filters, item, getFieldDecorator, data, {
                                            title,
                                            resource,
                                            setFieldsValue,
                                            defaultValueType: 'Boolean',
                                            defaultValue: true,
                                        })
                                    } else if (item === 'type') {
                                        return (<Form.Item key={'type'} label={'Select Spare Type'}>
                                            {getFieldDecorator('type', {
                                                rules: [{ required: true, message: `Spare Type is required!` }],
                                                initialValue: data && data.type && data.type._id,
                                            })(
                                                <Select
                                                    showSearch
                                                    style={{
                                                        width: '80%',
                                                        marginTop: '-10px'
                                                    }}
                                                    placeholder="Select Spare Type"
                                                    filterOption={(input, option) =>
                                                        (option.props.children + '').toLowerCase().indexOf((input + '').toLowerCase()) >= 0
                                                    }
                                                    onChange={this.handleTypeSelect.bind(this, typeData, getFieldDecorator)}
                                                    // onSelect={this.props.fetchSptListBySta}
                                                    disabled={(title === 'EDIT' && filters['type'] && filters['type'].options.disabledOnEdit) || false}
                                                >
                                                    {typeData && typeData.map(st =>
                                                        <Select.Option key={st._id}
                                                            value={st._id}>{st.name}</Select.Option>)}
                                                </Select>)}
                                            {
                                                filters[item].options.master ?
                                                    <MasterModal subMaster={(subMaster) || false}
                                                        superMaster={(superMaster) || false}
                                                        resource={(resource)}
                                                        item={filters[item].options.ref}
                                                        title={'CREATE'} /> : ''
                                            }
                                        </Form.Item>);
                                    } else if (item === 'compatibleSpare') {
                                        return (
                                            <Form.Item key={'compatibleSpare'} label={'Enter Compatible Spare Part'}>
                                                {getFieldDecorator(`compatibleSpare`, {
                                                    initialValue: data && data.compatibleSpare && data.compatibleSpare.map(c => c._id),
                                                })
                                                    (<Select
                                                        showSearch
                                                        mode="multiple"
                                                        style={{ width: '100%' }}
                                                        filterOption={(input, option) =>
                                                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                        }
                                                        onSearch={this.props.fetchSpare}
                                                        placeholder={`Please Enter Compatible Spare Part`}
                                                    >
                                                        {(data.compatibleSpare || []).map(item =>
                                                            <Select.Option key={item._id}
                                                                value={item._id}>{item.name}</Select.Option>)}
                                                        {(sparePartData || []).map(item =>
                                                            <Select.Option key={item._id}
                                                                value={item._id}>{item.name}</Select.Option>)}
                                                    </Select>)
                                                }
                                            </Form.Item>);
                                    } else if (item === 'documents') {
                                        return <DocumentList history={this.props.history} match={this.props.match}
                                            key={item}
                                            item={filters[item]} form={form} data={data[item]}
                                            subDocumentFilters={subDocumentFilters}
                                            getDocumentData={this.getDocumentData} />
                                    }
                                })}
                                {selectedType && selectedType.attributes && selectedType.attributes.length ?
                                    (<div key={'attribute'} style={style}>
                                        {
                                            selectedType.attributes && selectedType.attributes.map((att, index) => {
                                                return (<Row key={`${att._id}`}>
                                                    <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                                                        <Form.Item key={`${att._id}_name`} label={`Enter ${att.name} name`}>
                                                            {getFieldDecorator(`${att._id}_name`, {
                                                                validateTrigger: ['onChange', 'onBlur'],
                                                                rules: [{
                                                                    required: true,
                                                                    message: `${att.name} name is required!`
                                                                }],
                                                                initialValue: data.typeAttributes && data.typeAttributes.length && data.typeAttributes[index] ? data.typeAttributes[index].name : (att.hasContent && att.content.length === 1) ? att.content[0] && att.content[0].name || '' : '',
                                                            })(att.hasContent && att.content.length ?
                                                                <Select placeholder={`Select ${att.name} name`}
                                                                    onChange={(val) => this.handleSelectAttributeName(index, att._id, val)}
                                                                    style={{ width: '90%' }}>{att.content.map(con =>
                                                                        <Select.Option key={con.name}
                                                                            value={con.name}>{con.name}</Select.Option>)}</Select> :
                                                                <Input placeholder={`${att.name} name`}
                                                                    style={{ width: '90%' }} />)
                                                            }
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                                                        <Form.Item key={`${att._id}_code`}
                                                            label={att.isCodeRequired ? `Enter ${att.name} code` : ''}>
                                                            {getFieldDecorator(`${att._id}_code`, {
                                                                validateTrigger: ['onChange', 'onBlur'],
                                                                rules: [{
                                                                    required: att.isCodeRequired,
                                                                    message: `${att.name} code is required!`
                                                                }],
                                                                initialValue: data.typeAttributes && data.typeAttributes.length && data.typeAttributes[index] ? data.typeAttributes[index].code : (att.hasContent && att.content.length === 1) ? att.content[0] && att.content[0].code || '' : '',
                                                            })(att.hasContent && att.content.length ?
                                                                <Select style={{
                                                                    width: '50%',
                                                                    visibility: !att.isCodeRequired ? 'hidden' : ''
                                                                }}
                                                                    disabled
                                                                    placeholder={`Select ${att.name} code`}>
                                                                    {att.content.map(con => {
                                                                        if (con.code)
                                                                            return (<Select.Option key={con.code}
                                                                                value={con.code}>{con.code}</Select.Option>)
                                                                    })
                                                                    }
                                                                </Select> :
                                                                <Input placeholder={`${att.name} code`}
                                                                    disabled={!att.isCodeRequired}
                                                                    style={{
                                                                        width: '50%',
                                                                        visibility: !att.isCodeRequired ? 'hidden' : ''
                                                                    }} />)
                                                            }
                                                        </Form.Item>
                                                    </Col>
                                                </Row>);
                                            })
                                        }
                                    </div>)
                                    : data.typeAttributes && data.typeAttributes.length ?
                                        (<div key={'attributeUp'} style={style}>
                                            {
                                                data.typeAttributes && data.typeAttributes.map((att, index) => {
                                                    return (<Row key={`${att.attribute._id}`}>
                                                        <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                                                            <Form.Item key={`${att.attribute._id}_name`}
                                                                label={`Enter ${att.attribute.name} name`}>
                                                                {getFieldDecorator(`${att.attribute._id}_name`, {
                                                                    validateTrigger: ['onChange', 'onBlur'],
                                                                    rules: [{
                                                                        required: true,
                                                                        message: `${att.attribute.name} name is required!`
                                                                    }],
                                                                    initialValue: att.name,
                                                                })(<Input placeholder={`${att.attribute.name} name`}
                                                                    style={{ width: '90%' }} />)
                                                                }
                                                            </Form.Item>
                                                        </Col>
                                                        <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                                                            <Form.Item key={`${att.attribute._id}_code`}
                                                                label={`Enter ${att.attribute.name} code`}>
                                                                {getFieldDecorator(`${att.attribute._id}_code`, {
                                                                    validateTrigger: ['onChange', 'onBlur'],
                                                                    rules: [{
                                                                        required: att.attribute.isCodeRequired,
                                                                        message: `${att.attribute.name} code is required!`
                                                                    }],
                                                                    initialValue: att.code,
                                                                })(<Input placeholder={`${att.attribute.name} code`}
                                                                    disabled={!att.attribute.isCodeRequired}
                                                                    style={{ width: '50%' }} />)
                                                                }
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>);
                                                })
                                            }
                                        </div>) : null}

                                <Form.Item>
                                    <Button type="primary" className="gx-mb-0" htmlType="submit">
                                        Generate Name
                                    </Button>
                                    <Button type="default" className="gx-mb-0" htmlType="button"
                                        onClick={() => this.props.history.goBack()}>
                                        Back
                                    </Button>
                                </Form.Item>
                            </Form>
                        }
                    </Card>
                </Spin>
            </div>
        );
    }
}

const
    StepCreateForm = Form.create({
        name: 'global_state',
        onFieldsChange(props, changedFields) {
            props.onChange(changedFields);
        },
    })(StepCreate);
export default StepCreateForm;
